import KeycloakAdminClient from "@keycloak/keycloak-admin-client";
import { getAuthorizationHeaders } from "../../utils/getAuthorizationHeaders";
import { CreateLdapSchema } from "../pages/LdapPages/CreateLdap";

class LdapService extends KeycloakAdminClient {
  constructor() {
    super();
  }

 async pointLDAPConnection(
    {
      ldapHost,
      ldapPort,
      ldapBindUsername,
      ldapBindPassword,
    }: Omit<
      CreateLdapSchema,
      "id" | "name" | "ldapDomainName" | "ldapOrganizationalUnit"
    >,
    adminClient: KeycloakAdminClient
  ) {
    let data = false;
    try {

      const response = await fetch(
        `${adminClient.baseUrl}/realms/${adminClient.realmName}/ldap-api/testLDAPConnection`,
        {
          signal: AbortSignal.timeout(5000),
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...getAuthorizationHeaders(await adminClient.getAccessToken()),
          },
          body: JSON.stringify({
            ldapHost,
            ldapPort,
            ldapBindUsername,
            ldapBindPassword
          }),
        },
      );
      data = response.ok;
    } catch (error) {
      console.error("LDAP connection test failed:", error);
      data = false;
    }

    return data;
  }
}

export default new LdapService();
